import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import LoginComponent from "../components/login/login";
import ForgotPasswordComponent from "../components/login/forgotPassword";
import DashBoardComponent from "../components/dashboard/dashboard";
import PoojaMasterListComponent from "../components/admin/poojaMasterList";
import JaThaPraMasterListComponent from "../components/admin/jaThaPraMasterList";
import NakshatraMasterListComponent from "../components/admin/nakshatraMasterList";
import GotraMasterListComponent from "../components/admin/gotraMasterList";
import PrathanaMasterListComponent from "../components/admin/prathanaMasterList";
import EkadasiMasterListComponent from "../components/admin/ekadasiMasterList";
import UserManagerListComponent from "../components/admin/userManagerList";
import PaymentTransactionListComponent from "../components/admin/paymentTransactionList";
import AuditStampingListComponent from "../components/admin/auditStampingList";
import GenerateReceiptComponent from "../components/receipts/generateReceipts";
import PrintReceiptListComponent from "../components/receipts/printReceiptsList";
import KanikaReceiptComponent from "../components/receipts/kanikaReceipt";
import PrathanaReceiptComponent from "../components/receipts/prathanaReceipt";
import DailyReportComponent from "../components/reports/dailyReport";
import DailyPoojaReportComponent from "../components/reports/dailyPoojaReport";
import DailySevaCollectionComponent from "../components/reports/dailySevaCollection";
import PeriodicalReportComponent from "../components/reports/periodicalReport";
import SevaWiseReportComponent from "../components/reports/sevaWiseReport";
import CollectionDetailsComponent from "../components/reports/collectionDetails";
import CancelReceiptComponent from "../components/admin/cancelReceipt";
import ChangePasswordComponent from "../components/admin/changePassword";
import SignupComponent from "../components/signup/signup";
import UserReceiptsListComponent from "../components/receipts/userReceiptsList";
import SessionTimeoutManager from "./SessionTimeoutManager";


function AppRoutes() {

  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  // Redirect to /login if user is not logged in and not on login page
  useEffect(() => {
    const publicPaths = ["/", "/login", "/sign-up", "/forgot-password"];
    if (!user && !publicPaths.includes(location.pathname)) {
      navigate("/login");
    }
  }, [user, location.pathname, navigate]);

  const hideHeader = ["/", "/login", "/sign-up", "/forgot-password"].includes(location.pathname);
  return (
    <>
      <SessionTimeoutManager />
      {!hideHeader}

      <Routes>
        <Route path="/" element={<LoginComponent />} />
        <Route path="/login" element={<LoginComponent />} />
        <Route path="/forgot-password" element={<ForgotPasswordComponent />} />
        <Route path="/dashboard" element={<DashBoardComponent />} />
        <Route path="/pooja-list" element={<PoojaMasterListComponent />} />
        <Route path="/ja-tha-pra" element={<JaThaPraMasterListComponent />} />
        <Route path="/nakshatra-list" element={<NakshatraMasterListComponent />} />
        <Route path="/gotra-list" element={<GotraMasterListComponent />} />
        <Route path="/prathana-mandir" element={<PrathanaMasterListComponent />} />
        <Route path="/ekadasi" element={<EkadasiMasterListComponent />} />
        <Route path="/user-list" element={<UserManagerListComponent />} />
        <Route path="/payment-transactions" element={<PaymentTransactionListComponent />} />
        <Route path="/audit-stamping" element={<AuditStampingListComponent />} />
        <Route path="/generate-receipts" element={<GenerateReceiptComponent />} />
        <Route path="/kanika-receipts" element={<KanikaReceiptComponent />} />
        <Route path="/prathana-receipts" element={<PrathanaReceiptComponent />} />
        <Route path="/print-receipts" element={<PrintReceiptListComponent />} />
        <Route path="/daily-reports" element={<DailyReportComponent />} />
        <Route path="/daily-pooja-reports" element={<DailyPoojaReportComponent />} />
        <Route path="/daily-seva-collection" element={<DailySevaCollectionComponent />} />
        <Route path="/periodic-reports" element={<PeriodicalReportComponent />} />
        <Route path="/sevawise-reports" element={<SevaWiseReportComponent />} />
        <Route path="/collection-details-reports" element={<CollectionDetailsComponent />} />
        <Route path="/cancel-receipt" element={<CancelReceiptComponent />} />
        <Route path="/change-passsword" element={<ChangePasswordComponent />} />
        <Route path="/sign-up" element={<SignupComponent />} />
        <Route path="/user-receipts" element={<UserReceiptsListComponent />} />
      </Routes>

    </>
  );

}
export default AppRoutes;
